import { httpPost, httpPatchMerge, httpDelete } from './http'
import type { TEntityId } from '~/types/models'
import type { ISupplierLastSelectedState } from '~/types/supplier/models'

const apiEntityPath = '/api/supplierlastselectedstates'

export async function createSupplierLastSelectedState(
  entity: ISupplierLastSelectedState
) {
  const callingMn = createSupplierLastSelectedState.name
  const apiPath = apiEntityPath
  return httpPost<ISupplierLastSelectedState>({
    callingMn,
    apiPath,
    entity,
  })
}

export async function updateSupplierLastSelectedState(
  entityData: Partial<ISupplierLastSelectedState>,
  id: TEntityId
) {
  const callingMn = updateSupplierLastSelectedState.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialSupplierLastSelectedState = Partial<ISupplierLastSelectedState>
  return httpPatchMerge<TPartialSupplierLastSelectedState>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteSupplierLastSelectedState(
  entityData: ISupplierLastSelectedState
) {
  const callingMn = deleteSupplierLastSelectedState.name
  const apiPath = apiEntityPath
  return httpDelete<ISupplierLastSelectedState>({
    callingMn,
    apiPath,
    entityData,
  })
}
